module.exports = __webpack_public_path__ + "static/img/service_bg1.49bbf20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service_bg1.png
// module id = 6e4W
// module chunks = 0